import ko from "knockout";
import _ from "lodash";

/**
 * This was based on http://www.thaemlitz.com/john/javascript-ip-subnet-calculator.html
 * ******************************************************************************
 * Feel free to use this code.  Leave my comments in place please.
 * JavaScript Subnet Calculator written by John Thaemltiz
 * *****************************************************************************
 **/

/*jshint bitwise: false*/

const IPV4_ROOT_REGEX =
    "(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])";

const IPV6_ROOT_REGEX =
    "((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|" +
    "(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|" +
    "(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|" +
    "(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|" +
    "(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|" +
    "(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|" +
    "(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|" +
    "(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))(%.+)?";

const PORT_REGEX = "(:[0-9]{1,5})";

// Convert a subnet mask array into CIDR (# of bits) (255.255.255.0 = 24 etc.)
const octet2cidr = function (aMask) {
    let mask = octet2dec(aMask);
    // get binary string
    mask = mask.toString(2);
    // return mask length
    const maskLength = mask.indexOf(0);
    return maskLength >= 0 ? maskLength : 32;
};

// Convert CIDR to array of 4 ints (Classless Inter Domain Routing)
const cidr2octet = function (bits) {
    bits = parseInt(bits);
    if (bits < 0 || bits > 32) {
        return [];
    }

    // make up our mask
    const ones = "11111111111111111111111111111111";
    let mask = parseInt(ones.substring(0, bits), 2);
    const shift = 32 - bits;
    // poor mans bit shift because javascript uses 32 bit integers
    mask = mask * Math.pow(2, shift);

    return dec2octet(mask);
};

// Convert decimal to our array of 4 ints.
const dec2octet = function (d) {
    const zeros = "00000000000000000000000000000000";
    let b = d.toString(2);
    b = zeros.substring(0, 32 - b.length) + b;

    return [
        parseInt(b.substring(0, 8), 2), // 32 bit integer issue (d & 4278190080)/16777216   //Math.pow(2,32) - Math.pow(2,24);
        (d & 16711680) / 65536, // Math.pow(2,24) - Math.pow(2,16);
        (d & 65280) / 256, // Math.pow(2,16) - Math.pow(2,8);
        d & 255, // Math.pow(2,8)
    ];
};

// Convert our array of 4 ints into a decimal (watch out for 16 bit JS integers here)
const octet2dec = function (a) {
    // poor mans bit shifting (Int32 issue)
    let d = 0;
    d = d + parseInt(a[0]) * 16777216; // Math.pow(2,24);
    d = d + parseInt(a[1]) * 65536; // Math.pow(2,16);
    d = d + parseInt(a[2]) * 256; // Math.pow(2,8);
    d = d + parseInt(a[3]);
    return d;
};
/**
 * End code based on John Thaemltiz's code
 */

/**
 * Splits the CIDR address into ip address and prefix.  If you pass just an IP, or just a routing prefix
 * it will give you back the most it can.
 *
 * @param {string} cidrAddress - The cidr address to split
 * @returns {{ipAddress: string, routingPrefix: string}}
 */
const splitCidrAddress = function (cidrAddress) {
    let ip = "";
    let routingPrefix = "";

    if (cidrAddress) {
        const split = cidrAddress.split("/");
        ip = split.length > 0 ? split[0] : "";
        routingPrefix = split.length > 1 ? split[1] : "";
    }

    return {
        ipAddress: ip,
        routingPrefix: routingPrefix,
    };
};

/**
 * Splits an address IPv4/IPv6/hostname : Port into address and port
 * components
 * @param addressAndPort {string}
 * @returns {{address: string, port: string}}
 */
const splitAddressAndPort = function (addressAndPort) {
    let address = "";
    let port = "";

    if (addressAndPort) {
        let splitOn = "";

        // If they paste an IPv6 address with [], then just remove the [] and make it valid
        if (
            isIpv6(addressAndPort) ||
            isIpv6OrIpv6Port(addressAndPort) ||
            _.startsWith(addressAndPort, "[") ||
            _.endsWith(addressAndPort, "]")
        ) {
            splitOn = "]:";
        } else {
            splitOn = ":";
        }

        const split = addressAndPort.split(splitOn);
        address = _.trim(split.length > 0 ? split[0] : "", "[]");
        port = split.length > 1 ? split[1] : "";
    }

    return {
        address: address,
        port: port,
    };
};

const combineAddressAndPort = function (address, port) {
    if (port && isIpv6(address)) {
        address = "[" + address + "]";
    }

    return address + (port ? ":" + port : "");
};

/**
 * Combines ip address and prefix into CIDR format
 * @param {string} ipAddress - The ip address
 * @param {string} routingPrefix - The routing prefix
 * @returns {string} CIDR address e.g. 'X.X.X.X/24'
 */
const combineCidrAddress = function (ipAddress, routingPrefix) {
    return ipAddress + "/" + routingPrefix;
};

/**
 * Is this a valid IPv4 address?
 * @param {string} address - The string to check
 * @returns {boolean} Returns true if it's a valid IPv4 address
 */
const isIpv4 = function (address) {
    const regExp = new RegExp("^" + IPV4_ROOT_REGEX + "$");
    return regExp.test(address);
};

/**
 * Is this an IPv4 address or an IPv4 address with a Port?
 * 1.1.1.1:8000
 * @param {string} address - The string to check
 * @returns {boolean} Returns true if it's a valid IPv4 address with or without the port
 */
const isIpv4OrIpv4Port = function (address) {
    if (isIpv4(address)) {
        return true;
    }

    const regExp = new RegExp("^" + IPV4_ROOT_REGEX + PORT_REGEX + "$");
    return regExp.test(address);
};

/**
 * Is this a valid IPv4 address in CIDR notation?
 * @param {string} address - The string to check
 * @returns {boolean} Returns true if it's a valid IPv4 cidr address
 */
const isIpv4Cidr = function (address) {
    const regExp = new RegExp(
        "^" + IPV4_ROOT_REGEX + "(\\/(\\d|[1-2]\\d|3[0-2]))$"
    );
    return regExp.test(address);
};

/**
 * Is this a valid IPv6 address?
 * fe80::2da9:3ee9:34a2:3334
 * @param {string} address - The string to check
 * @returns {boolean} Returns true if it's a valid IPv6 address
 */
const isIpv6 = function (address) {
    const regExp = new RegExp("^" + IPV6_ROOT_REGEX + "$");
    return regExp.test(address);
};

/**
 * Is this a valid IPv6 address or an IPv6 address with a Port?
 * fe80::2da9:3ee9:34a2:3334 or [fe80::2da9:3ee9:34a2:3334]:8000
 * @param {string} address - The string to check
 * @returns {boolean} Returns true if it's a valid IPv6 address with or without a port
 */
const isIpv6OrIpv6Port = function (address) {
    if (isIpv6(address)) {
        return true;
    }

    const regExp = new RegExp(
        "^\\[" + IPV6_ROOT_REGEX + "\\]" + PORT_REGEX + "$"
    );
    return regExp.test(address);
};

/**
 * Is this a valid IPv6 address in CIDR notation?
 * @param {string} address - The string to check
 * @returns {boolean} Returns true if it's a valid IPv6 cidr address
 */
const isIpv6Cidr = function (address) {
    const regExp = new RegExp(
        "^" + IPV6_ROOT_REGEX + "(\\/(\\d|\\d\\d|1[0-1]\\d|12[0-8]))$"
    );
    return regExp.test(address);
};

/**
 * Is this a valid IPv4 subnet mask?
 * @param {string} address - The string to check
 * @param {boolean} allowDottedZero - Allow '0.0.0.0' as a valid subnet mask
 * @returns {boolean} Returns true if it's a valid IPv4 subnet mask
 */
const isIpv4SubnetMask = function (address, allowDottedZero) {
    if (allowDottedZero && address === "0.0.0.0") {
        return true;
    }

    const regExp = new RegExp(
        "^((128|192|224|240|248|252|254)\\.0\\.0\\.0)|" +
            "(255\\.(((0|128|192|224|240|248|252|254)\\.0\\.0)|" +
            "(255\\.(((0|128|192|224|240|248|252|254)\\.0)|" +
            "255\\.(0|128|192|224|240|248|252|254|255)))))$"
    );
    return regExp.test(address);
};

/**
 * Takes the current routing prefix and converts it into an IPv4 subnet mask.
 * @param {string} routingPrefix
 * @returns {string} The subnet mask
 */
const getIpv4SubnetMask = function (routingPrefix) {
    // Parse it out of the IP address and convert into 255.255.255.255 format
    if (routingPrefix) {
        return cidr2octet(routingPrefix).join(".");
    }

    return "";
};

function updateIpv4FromCidrAddress(cidrObservable, newValue) {
    if (isIpv4Cidr(newValue)) {
        let newIPv4Address, newIPv4SubnetMask;

        if (newValue) {
            const ipv4parts = splitCidrAddress(newValue);
            newIPv4Address = ipv4parts.ipAddress;
            newIPv4SubnetMask = getIpv4SubnetMask(ipv4parts.routingPrefix);
        } else {
            newIPv4Address = undefined;
            newIPv4SubnetMask = undefined;
        }

        if (newIPv4Address !== cidrObservable.ipv4IpAddress()) {
            cidrObservable.ipv4IpAddress(newIPv4Address);
        }
        if (newIPv4SubnetMask !== cidrObservable.ipv4SubnetMask()) {
            cidrObservable.ipv4SubnetMask(newIPv4SubnetMask);
        }
    }
}

/**
 * Updates self.cidrAddress from the newValue and ipv4Subnet properties.
 * @param {function} cidrObservable - An observable that has been setup with ipv4IpAddress and ipv4SubnetMask sub-observables
 * @param {boolean} allowDottedZero - Allow '0.0.0.0' as a valid subnet mask
 * @param {string} newValue - The new value typed in by the user
 */
const updateCidrAddressFromNewIPv4Address = function (
    cidrObservable,
    allowDottedZero,
    newValue
) {
    if (
        isIpv4(newValue) &&
        isIpv4SubnetMask(cidrObservable.ipv4SubnetMask(), allowDottedZero)
    ) {
        cidrObservable(
            combineCidrAddress(
                newValue,
                octet2cidr(cidrObservable.ipv4SubnetMask().split("."))
            )
        );
    } else if (!isIpv4Cidr(newValue)) {
        // I want observable to have a different value, so it appears as changed. Even if it's invalid
        cidrObservable(newValue);
    }
};

/**
 * Updates self.cidrAddress from the ipv4Ip property and the newValue.
 * @param {function} cidrObservable - An observable that has been setup with ipv4IpAddress and ipv4SubnetMask sub-observables
 * @param {boolean} allowDottedZero - Allow '0.0.0.0' as a valid subnet mask
 * @param {string} newValue - The new value typed in by the user
 */
const updateCidrAddressFromNewSubnetMask = function (
    cidrObservable,
    allowDottedZero,
    newValue
) {
    if (
        isIpv4(cidrObservable.ipv4IpAddress()) &&
        isIpv4SubnetMask(newValue, allowDottedZero)
    ) {
        cidrObservable(
            combineCidrAddress(
                cidrObservable.ipv4IpAddress(),
                octet2cidr(newValue.split("."))
            )
        );
    } else if (!isIpv4Cidr(newValue)) {
        // I want observable to have a different value, so it appears as changed. Even if it's invalid
        cidrObservable(newValue);
    }
};

/**
 * For IPv4 Cidr addresses we want to expose them as separate IP and subnet mask fields.
 * This is just a utility method that adds observable.ipv4IpAddress and observable.ipv4SubnetMask
 * and also keeps the underlying cidr observable up to date as those parts change.
 * @param {function} ipv4CidrObservable - The observable that holds the IPv4 cidr address.  e.g. 1.1.1.1/20
 * @param {boolean} allowDottedZero - Allow '0.0.0.0' as a valid subnet mask
 * @param {function} onlyIf - onlyIf rules to apply to the ipv4IPAddress and ipv4SubnetMask validators
 */
const createIPv4NoCidrObservables = function (
    ipv4CidrObservable,
    allowDottedZero,
    onlyIf
) {
    // The IP address for this logical interface.  The ipAddress property from the server gives us CIDR, 127.0.0.1/24, and this property strips off the 24.
    ipv4CidrObservable.ipv4IpAddress = ko.observable();

    // Returns the subnet mask for IPv4 only!  Takes the CIDR self.ipAddress and gives you back a dotted decimal subnet mask.
    ipv4CidrObservable.ipv4SubnetMask = ko.observable();

    ipv4CidrObservable.ipv4IpAddress.extend({
        isIPv4OrCidr: {
            params: {
                isEmptyValid: false,
            },
            onlyIf: onlyIf,
        },
    });
    ipv4CidrObservable.ipv4SubnetMask.extend({
        isSubnetMask: {
            params: {
                isEmptyValid: false,
                allowDottedZero: allowDottedZero,
            },
            onlyIf: onlyIf,
        },
    });

    updateIpv4FromCidrAddress(ipv4CidrObservable, ipv4CidrObservable());

    ipv4CidrObservable.subscribe(
        _.partial(updateIpv4FromCidrAddress, ipv4CidrObservable)
    );

    ipv4CidrObservable.ipv4IpAddress.subscribe(
        _.partial(
            updateCidrAddressFromNewIPv4Address,
            ipv4CidrObservable,
            allowDottedZero
        )
    );
    ipv4CidrObservable.ipv4SubnetMask.subscribe(
        _.partial(
            updateCidrAddressFromNewSubnetMask,
            ipv4CidrObservable,
            allowDottedZero
        )
    );

    ipv4CidrObservable.ipv4IpAddress.focused = ko.observable();
    ipv4CidrObservable.ipv4IpAddress.focused.subscribe(function (newValue) {
        if (!newValue && isIpv4Cidr(ipv4CidrObservable.ipv4IpAddress())) {
            // We've just lost focus and the field contains a valid IPv4 CIDR address
            // Just update the cidr address and let it change the IPv4 values
            ipv4CidrObservable(ipv4CidrObservable.ipv4IpAddress());
            updateIpv4FromCidrAddress(ipv4CidrObservable, ipv4CidrObservable());
        }
    });
};

/**
 * Determines if the passed in ipAddress is a valid network IP based on the subnet mask provided
 * @param {function} ipAddress - The string that holds the IP address in regular or CIDR form.
 *                   If in CIDR notation, original network mask will be ignored and the one extracted
 *                   will be used.
 * @param {boolean} subnet mask - Allow '0.0.0.0' as a valid subnet mask
 * @param {function} true if when (ipAddress & subnet) matches ipAddress else false
 */
const isNetworkIPv4 = function (ipAddress, subnet) {
    const networkIPObj = {
        isValid: false,
        validNetworkIP: null,
    };

    if (isIpv4Cidr(ipAddress)) {
        const splitAddress = splitCidrAddress(ipAddress);
        ipAddress = splitAddress.ipAddress;
        subnet = cidr2octet(splitAddress.routingPrefix).join(".");
    }
    const tempArray = [];
    if (isIpv4(ipAddress) && isIpv4SubnetMask(subnet, true)) {
        const octet1 = ipAddress.split(".");
        const octet2 = subnet.split(".");

        if (octet1.length == octet2.length) {
            for (let i = 0; i < octet1.length; i++) {
                tempArray.push(parseInt(octet1[i]) & parseInt(octet2[i]));
            }
        }
        const networkIP = tempArray.join(".");

        networkIPObj.validNetworkIP = networkIP;

        if (networkIP === ipAddress) {
            networkIPObj.isValid = true;
        }
    }
    return networkIPObj;
};

/**
 * Ensure original string is padded to the correct length
 * @param {string} originalStr - String to be padded
 * @param {string} paddingStr - Padding string
 * @param {number} paddingNum - Padding number
 * @param {boolean} prepend - If true prepend, otherwise append
 * @returns {string} Padded string
 */
const addPaddingFill = function (originalStr, paddingStr, paddingNum, append) {
    const padding = new Array(paddingNum - originalStr.length + 1).join(
        paddingStr
    );

    //prepend
    if (!append) {
        return padding + originalStr;
    }
    //append
    return originalStr + padding;
};

/**
 * Covnerts IPv4 address to a hex octets in the form of ff:ff:ff:ff
 * @param {string} address - IPv4 address
 * @returns {array} Hex octet array
 */
const convertIPv4ToV6Group = function (address) {
    let v6Group = [];
    if (isIpv4(address)) {
        const octets = address.split(".");
        let octet = null;

        if (octets.length === 4) {
            for (let i = 0; i < octets.length; i++) {
                octet = parseInt(octets[i]).toString(16);
                octet = addPaddingFill(octet, "0", 2);
                octets[i] = octet;
            }
            v6Group = octets;
        }
    }
    return v6Group;
};

/**
 * Convert an IPv6 address to its canonical form.
 * @param {string} address - Any valid IPv6 address format.
 * @returns {array} IPv6 canonical array
 */
const convertIPv6ToCanonicalForm = function (address) {
    let groups = [];
    const numberOfGroups = 8;
    const halves = address.split("::");

    if (halves.length === 2) {
        let first = halves[0].split(":");
        let last = halves[1].split(":");

        if (first.length === 1 && first[0] === "") {
            first = [];
        }
        if (last.length === 1 && last[0] === "") {
            last = [];
        }
        const remaining = numberOfGroups - (first.length + last.length);
        if (remaining) {
            first.forEach(function (group) {
                groups.push(group);
            });
            for (let i = 0; i < remaining; i++) {
                groups.push(0);
            }
            last.forEach(function (group) {
                groups.push(group);
            });
        }
    } else if (halves.length === 1) {
        groups = address.split(":");
    } else {
        return [];
    }
    groups = groups.map(function (g) {
        const number = g.toString(16);
        return addPaddingFill(number, "0", 4);
    });
    if (groups.length !== numberOfGroups) {
        return [];
    }
    return groups;
};

/**
 * Given number of most significant bits, convert it to an appropriate hex nibble
 * @param {number} bits - Number of most significat bits. Must be <= 4.
 * @returns {string} Hexadecimal nibble
 */
const bitsToHexNibble = function (bits) {
    if (bits > 0 && bits <= 4) {
        const nibbleMask = "1111";
        let mask = parseInt(nibbleMask.substring(0, bits), 2);
        const shift = 4 - bits;
        mask = mask * Math.pow(2, shift);
        return mask.toString(16);
    }
    return null;
};

/**
 * Given number of most significant bits, convert it to an array of hexadecimal nibble groups
 * @param {number} bits - Number of most significat bits.
 * @returns {array} Array of hexadecimal nibbles
 */
const bitsToNibbles = function (bits) {
    const nibbles = [];

    if (bits > 0) {
        const fullNibbleGroups = parseInt(bits / 4);
        const partialNibbleGroups = parseInt(bits % 4);

        if (fullNibbleGroups > 0) {
            for (let i = 0; i < fullNibbleGroups; i++) {
                nibbles.push(bitsToHexNibble(4));
            }
        }
        if (partialNibbleGroups > 0) {
            nibbles.push(bitsToHexNibble(partialNibbleGroups));
        }
    }
    return nibbles;
};

/**
 * Ensure 4 nibbles per grouping
 * @param {array} nibblesArray - Nibbles array
 * @returns {array} V6 grouping array
 */
const nibblesToV6Groups = function (nibblesArray) {
    const v6Groups = [];
    let v6Group = "";
    const arrayLength = nibblesArray.length;
    let i = 0;
    for (i = 0; i < arrayLength; i++) {
        if (arrayLength < 4) {
            v6Group = v6Group + nibblesArray[i];
        } else {
            v6Group = v6Group + nibblesArray[i];
            if (v6Group.length === 4) {
                v6Groups.push(v6Group);
                v6Group = "";
            }
        }
    }
    if (v6Group.length > 0) {
        v6Groups.push(v6Group);
    }
    //ensure padding
    for (i = 0; i < v6Groups.length; i++) {
        const groupLength = v6Groups[i].length;
        if (groupLength !== 4) {
            v6Groups[i] = addPaddingFill(v6Groups[i], "0", 4, true);
        }
    }
    return v6Groups;
};

/**
 * Determines if the passed in ipv6Address is a valid network IP
 * @param {function} ipv6Address - The string that holds the IP address in CIDR form.
 */
const isNetworkIPv6 = function (ipv6Address) {
    let routingPrefix = null;
    let ipAddress = null;
    let ipv6NetworkMask = null;
    let i = 0;

    const networkIPObj = {
        isValid: false,
        validNetworkIP: null,
    };
    if (isIpv6Cidr(ipv6Address)) {
        const splitAddress = splitCidrAddress(ipv6Address);
        ipAddress = splitAddress.ipAddress;
        routingPrefix = parseInt(splitAddress.routingPrefix);

        //check for ipv6 and routing prefix
        if (isIpv6(ipAddress) && routingPrefix <= 128) {
            const nibbles = bitsToNibbles(routingPrefix);
            let v6Groups = nibblesToV6Groups(nibbles);

            if (v6Groups.length < 8) {
                v6Groups = v6Groups.join(":");
                v6Groups = v6Groups + "::";
            } else {
                v6Groups = v6Groups.join(":");
            }

            ipv6NetworkMask = convertIPv6ToCanonicalForm(v6Groups).join(":");
            //check if IPv4 address is appended
            if (ipAddress.indexOf(".") !== -1) {
                const ipAddressLength = ipAddress.length;
                const lastColon = ipAddress.lastIndexOf(":");

                const appendedIPv4 = ipAddress.substring(
                    lastColon + 1,
                    ipAddressLength
                );
                const v6Group = convertIPv4ToV6Group(appendedIPv4);

                ipAddress = ipAddress.substring(0, lastColon + 1); //extract IPv6 fields
                ipAddress =
                    ipAddress +
                    v6Group[0] +
                    v6Group[1] +
                    ":" +
                    v6Group[2] +
                    v6Group[3];
            }
            //convert ip to canonical form
            ipAddress = convertIPv6ToCanonicalForm(ipAddress).join(":");

            //proceed to AND the bits
            const networkMaskArray = ipv6NetworkMask.split(":");
            const ipAddresArray = ipAddress.split(":");

            const networkDestinationArray = [];
            //both should be the same length
            for (i = 0; i < networkMaskArray.length; i++) {
                const bitwiseANDResult =
                    parseInt(networkMaskArray[i], 16) &
                    parseInt(ipAddresArray[i], 16);

                networkDestinationArray.push(bitwiseANDResult.toString(16));
                networkDestinationArray[i] = addPaddingFill(
                    networkDestinationArray[i],
                    "0",
                    4
                );
            }
            let removedV6Group = false;
            //remove zero v6 groups
            for (i = networkDestinationArray.length - 1; i >= 0; i--) {
                if (networkDestinationArray[i] !== "0000") {
                    break;
                } else {
                    networkDestinationArray.splice(i, 1);
                    removedV6Group = true;
                }
            }
            let networkDestination = networkDestinationArray.join(":");

            if (removedV6Group) {
                networkDestination = networkDestination + "::";
            }
            networkIPObj.validNetworkIP =
                networkDestination + "/" + routingPrefix;
            networkDestination =
                convertIPv6ToCanonicalForm(networkDestination).join(":");

            if (networkDestination === ipAddress) {
                networkIPObj.isValid = true;
            }
        }
    }

    return networkIPObj;
};

const isHostname = function (hostName) {
    const regExp = new RegExp("^[a-zA-Z0-9]+[a-zA-Z0-9.-]*$");
    return regExp.test(hostName);
};

// This check is pretty simple and mainly just validates the uri contains valid characters in general
const isUri = function (uri) {
    const regExp = new RegExp(
        "^[a-zA-Z0-9]+[a-zA-Z0-9.:\\/_~?#[\\]@!&'()+,;=\\$\\*-]*$"
    );
    return regExp.test(uri);
};

const isPort = function (port) {
    if (!/^\d+$/.test(port)) {
        return false;
    }

    const portNum = Number(port);
    if (portNum <= 0 || portNum > 65535) {
        return false;
    }

    return true;
};
const isFQDN = function (value) {
    return (
        /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-_]{0,61}[a-zA-Z0-9])(\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-_]{0,61}[a-zA-Z0-9]))*$/.exec(
            value
        ) !== null
    );
};
const isMAC = function (value) {
    return /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/.exec(value) !== null;
};

export default {
    isIpv4: isIpv4,
    isIpv4OrIpv4Port: isIpv4OrIpv4Port,
    isIpv6: isIpv6,
    isIpv6OrIpv6Port: isIpv6OrIpv6Port,
    isIpv4Cidr: isIpv4Cidr,
    isIpv6Cidr: isIpv6Cidr,
    isIpv4SubnetMask: isIpv4SubnetMask,
    createIPv4NoCidrObservables: createIPv4NoCidrObservables,
    updateIpv4FromCidrAddress: updateIpv4FromCidrAddress,
    octet2cidr: octet2cidr,
    cidr2octet: cidr2octet,
    splitCidrAddress: splitCidrAddress,
    combineCidrAddress: combineCidrAddress,
    splitAddressAndPort: splitAddressAndPort,
    combineAddressAndPort: combineAddressAndPort,
    isNetworkIPv4: isNetworkIPv4,
    addPaddingFill: addPaddingFill,
    convertIPv4ToV6Group: convertIPv4ToV6Group,
    convertIPv6ToCanonicalForm: convertIPv6ToCanonicalForm,
    bitsToHexNibble: bitsToHexNibble,
    bitsToNibbles: bitsToNibbles,
    nibblesToV6Groups: nibblesToV6Groups,
    isNetworkIPv6: isNetworkIPv6,
    isHostname: isHostname,
    isUri: isUri,
    isPort: isPort,
    isFQDN: isFQDN,
    isMAC: isMAC,
};
